import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id CF8F9CE5-0B38-4412-A3DD-F9E333C23EF6
 * name message-minus
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-minus.svg
 * tags
 */
export const MessageMinusIcon = createSvgIcon(<><path d="M20 2C21.11 2 22 2.9 22 4V16C22 17.11 21.11 18 20 18H6L2 22V4C2 2.89 2.9 2 4 2H20M8 9V11H16V9H8Z" /></>, 'MessageMinusIcon');
export default MessageMinusIcon